import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

const RegistrationButton = ({ loading, confirmationDialog, formik }) => {
  return (
    <div id="continue_button" style={{ marginTop: 20, textAlign: 'center' }}>
      {!loading ? (
        <span>
          <Button 
            type="submit" 
            variant={{ priority: 'high', size: 'large' }} 
            style={{ width: '100%' }}
            onPress={() => {
              if (formik) {
                formik.handleSubmit();
              }
            }}
          >
            {confirmationDialog.confirm}
          </Button>
        </span>
      ) : (
        <span>
          <Button type="button" style={{ width: '100%' }} disabled>
            <i className="fa fa-refresh fa-spin" />
            {confirmationDialog.LOADING}
          </Button>
        </span>
      )}
    </div>
  );
};

RegistrationButton.propTypes = {
  loading: PropTypes.bool.isRequired,
  confirmationDialog: PropTypes.shape({
    confirm: PropTypes.string,
    LOADING: PropTypes.string
  }).isRequired,
  formik: PropTypes.shape({
    handleSubmit: PropTypes.func
  })
};

export default RegistrationButton;
